import i18n from '@/i18n';
import { eventFieldFormatters } from './components/AgGridUtils';

// Call Logs Default Grid State
export const callLogDefaultColStateAdmin = [
  {
    colId: 'callDt',
    hide: false,
    flex: 1,
    pinned: 'left',
    sort: 'desc'
  },
  {
    colId: 'campaignName',
    sort: null,
    hide: false,
    flex: 3
  },
  {
    colId: 'publisherName',
    sort: null,
    hide: false,
    flex: 3
  },
  {
    colId: 'inboundPhoneNumber',
    sort: null,
    hide: false,
    flex: 2
  },
  {
    colId: 'number',
    sort: null,
    hide: false,
    flex: 2
  },
  {
    colId: 'timeToCallInSeconds',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'isDuplicate',
    sort: null,
    hide: false,
    flex: 1
  },
  // TODO: Use reference data of ag-grid
  {
    colId: 'endCallSource',
    sort: null,
    hide: false,
    flex: 1,
  },
  {
    colId: 'timeToConnectInSeconds',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'targetName',
    sort: null,
    hide: false,
    flex: 3
  },
  {
    colId: 'conversionAmount',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'payoutAmount',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'callLengthInSeconds',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'recordingUrl',
    sort: null,
    hide: false,
    width: 67,
    pinned: 'right',
    flex: null
  },
  {
    colId: 'hasTranscription',
    sort: null,
    hide: false,
    width: 67,
    pinned: 'right',
    flex: null
  },
  {
    colId: 'action',
    sort: null,
    hide: false,
    width: 75,
    pinned: 'right',
    flex: null
  },
  
];

export const callLogDefaultColStatePub = [
  {
    colId: 'callDt',
    hide: false,
    flex: 1,
    pinned: 'left',
    sort: 'desc'
  },
  {
    colId: 'campaignName',
    sort: null,
    hide: false,
    flex: 3
  },
  {
    colId: 'inboundPhoneNumber',
    sort: null,
    hide: false,
    flex: 2
  },
  {
    colId: 'number',
    sort: null,
    hide: false,
    flex: 2
  },
  {
    colId: 'numberPoolName',
    sort: null,
    hide: false,
    flex: 2
  },
  {
    colId: 'isDuplicate',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'timeToCallInSeconds',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'timeToConnectInSeconds',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'connectedCallLengthInSeconds',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'payoutAmount',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'callLengthInSeconds',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'recordingUrl',
    sort: null,
    hide: false,
    width: 85,
    pinned: 'right'
  },
];

export const callLogDefaultColStateBuyer = [
  {
    colId: 'callDt',
    hide: false,
    flex: 1,
    pinned: 'left',
    sort: 'desc'
  },
  {
    colId: 'inboundPhoneNumber',
    sort: null,
    hide: false,
    flex: 2
  },
  {
    colId: 'number',
    sort: null,
    hide: false,
    flex: 2
  },
  {
    colId: 'timeToCallInSeconds',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'isDuplicate',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'buyerTimeToConnectInSeconds',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'buyerConnectedCallLengthInSeconds',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'buyerTargetName',
    sort: null,
    hide: false,
    flex: 3
  },
  {
    colId: 'buyerConversionAmount',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'buyerCallLengthInSeconds',
    sort: null,
    hide: false,
    flex: 1
  },
  {
    colId: 'recordingUrl',
    sort: null,
    hide: false,
    width: 85,
    pinned: 'right'
  },
  {
    colId: 'action',
    sort: null,
    hide: false,
    width: 75,
    pinned: 'right'
  }
];

export const defaultCallLogColDef = [
  {
    id: 'callDt',
    roles: ['admin', 'user', 'affiliate', 'buyer']
  },
  {
    id: 'campaignName',
    roles: ['admin', 'user', 'affiliate']
  },
  {
    id: 'publisherName',
    roles: ['admin', 'user']
  },
  {
    id: 'inboundPhoneNumber',
    roles: ['admin', 'user', 'affiliate', 'buyer']
  },
  {
    id: 'number',
    roles: ['admin', 'user', 'affiliate']
  },
  {
    id: 'timeToCallInSeconds',
    roles: ['admin', 'user', 'affiliate', 'buyer']
  },
  {
    id: 'isDuplicate',
    roles: ['admin', 'user', 'affiliate']
  },
  {
    id: 'endCallSource',
    roles: ['admin', 'user']
  },
  {
    id: 'timeToConnectInSeconds',
    roles: ['admin', 'user', 'affiliate']
  },
  {
    id: 'targetName',
    roles: ['admin', 'user']
  },
  {
    id: 'conversionAmount',
    roles: ['admin', 'user']
  },
  {
    id: 'payoutAmount',
    roles: ['admin', 'user', 'affiliate']
  },
  {
    id: 'callLengthInSeconds',
    roles: ['admin', 'user', 'affiliate']
  },
  {
    id: 'recordingUrl',
    roles: ['admin', 'user', 'affiliate', 'buyer']
  },
  {
    id: 'hasTranscription',
    roles: ['admin', 'user']
  },
  {
    id: 'inboundCallId',
    roles: ['admin', 'user', 'affiliate', 'buyer']
  },
  {
    id: 'hasConnected',
    roles: ['admin', 'user', 'affiliate']
  },
  {
    id: 'hasConverted',
    roles: ['admin', 'user']
  },
  {
    id: 'isLive',
    roles: ['admin', 'user', 'affiliate', 'buyer']
  },
  {
    id: 'wasBlocked',
    roles: ['admin', 'user']
  },
  {
    id: 'connectedCallLengthInSeconds',
    roles: ['admin', 'user', 'affiliate']
  },
  {
    id: 'buyerTimeToConnectInSeconds',
    roles: ['buyer']
  },
  {
    id: 'buyerConnectedCallLengthInSeconds',
    roles: ['buyer']
  },
  {
    id: 'buyerTargetName',
    roles: ['buyer']
  },
  {
    id: 'buyerConversionAmount',
    roles: ['buyer']
  },
  {
    id: 'buyerCallLengthInSeconds',
    roles: ['buyer']
  }
];

const iconMappingForEndCallSource = {
  system: 'fa fa-server',
  unknown: 'fa fa-question',
  caller: 'fa fa-mobile f-s-16',
  target: 'fa fa-dot-circle-o'
};

const dateFormatter = eventFieldFormatters['date'];

export const specificColsProperties = {
  'callDt': {
    cellRenderer: 'callLogExpandDetailCellRenderer',
    cellRendererParams: {
      callConnectionStatusTooltips: {
        'COMPLETED': i18n.tc('COMPLETED'),
        'COMPLETED_NO_CONVERSION': i18n.tc('COMPLETED_NO_CONVERSION'),
        'PAID_OUT': i18n.tc('PAID_OUT'),
        'CONVERTED': i18n.tc('CONVERTED'),
        'BLOCKED': i18n.tc('BLOCKED'),
        'NOT_CONNECTED': i18n.tc('NOT_CONNECTED'),
        'LIVE': i18n.tc('LIVE'),
      }
    },
    cellClass: 'mark-call',
    lockPosition: true,
    lockVisible: false,
    lockPinned: true,
    flex: 2,
    maxWidth: 150,
    suppressMenu: true,
    suppressSizeToFit: true,
    valueFormatter: ({ value }) => {
      return dateFormatter(value);
    }
  },
  'recordingUrl': {
    headerName: 'Recording',
    cellRenderer: 'recordingCellRenderer',
    cellClass: 'text-center',
    width: 30,
    maxWidth: 90,
    resizable: false,
    suppressMenu: true,
    lockPinned: true,
    pinned: 'right'
  },
  'hasTranscription': {
    headerName: 'Transcription',
    cellRenderer: 'transcriptionCellRenderer',
    cellClass: 'text-center',
    width: 30,
    maxWidth: 90,
    resizable: false,
    suppressMenu: true,
    lockPinned: true,
    pinned: 'right'
  },
  'number': {
    flex: 1,
    minWidth: 110,
  },
  'inboundPhoneNumber': {
    flex: 1,
    minWidth: 110,
    // maxWidth: 150,
    cellRenderer(params) {
      const isBlocked = params.data?.wasBlocked && params.data?.blockReason?.toLowerCase() === 'blocked by account';
      return Object.assign(document.createElement('span'), {
        title: isBlocked ? 'Blocked Call' : '',
        className: `filterable-cell ${isBlocked ? 'text-danger' : ''}`,
        textContent: params.value,
      });
    }
  },
  'endCallSource': {
    flex: 1,
    maxWidth: 80,
    cellRenderer(params) {
      return Object.assign(document.createElement('span'), {
        title: params.value,
        className: `filterable-cell ${iconMappingForEndCallSource[params.value?.toLowerCase()]}`,
      });
    },
    cellClass: 'text-center'
  },
  'isDuplicate': {
    flex: 1,
    maxWidth: 75
  },
  'wasConversionAdjusted': {
    // maxWidth:135
  },
  'wasPayoutAdjusted': {
    // maxWidth:135
  },
  'timeToCallInSeconds': {
    flex: 1,
    minWidth: 70
  },
  'timeToConnectInSeconds':{
    flex: 1,
    minWidth: 70
  },
  'callLengthInSeconds': {
    flex: 1,
    minWidth: 70,
    headerName: 'Duration'
  },
  'campaignName': {
    flex: 4,
  },
  'publisherName': {
    flex: 4,
  },
  'numberPoolName': {
    flex: 4,
  },
  'targetName': {
    flex: 4,
  },
  'conversionAmount': {
    flex: 1,
    maxWidth: 100,
    minWidth: 65
  },
  'payoutAmount': {
    flex: 1,
    maxWidth: 100,
    minWidth: 65
  },
};